module.exports = __webpack_public_path__ + "static/media/apple-iphone12pro-graphite-portrait.7cc10075.png";